import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import ScrollToTop from './utils/scrollToTop';
import GlobalStyle from './styles/global';
import Routes from './routes';

const App: React.FC = () => (
  <>
    <BrowserRouter>
      <ScrollToTop />
      <Routes />
    </BrowserRouter>
    <GlobalStyle />
  </>
);

export default App;
